import { render } from "./SubscribingComponent.vue?vue&type=template&id=4665556c&ts=true"
import script from "./SubscribingComponent.vue?vue&type=script&lang=ts"
export * from "./SubscribingComponent.vue?vue&type=script&lang=ts"

import "./SubscribingComponent.vue?vue&type=style&index=0&id=4665556c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__